import {
  Box,
  DialogContent,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import {
  CustomButton,
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
} from '../../../../../common/components';
import { MESSAGES } from '../../../constants/contractsConstants';

const SubscribersTab = ({
  localContract,
  isArchived,
  isReadOnly = false,
  handleOpenSubscriberDialog,
  handleEditSubscriber,
  handleDeleteSubscriber,
}) => {
  const disableEdition = isReadOnly || isArchived;

  return (
    <Box sx={{ width: '100%' }}>
      <DialogContent sx={{ display: 'flex' }}>
        <Box sx={{ width: '100%' }}>
          <Grid container justifyContent="center" alignItems="center" sx={{ marginTop: 4 }}>
            <Box>
              <CustomButton
                variant="contained"
                onClick={handleOpenSubscriberDialog}
                buttonIcon={PersonAddIcon}
                disabled={disableEdition}
                sx={{ marginBottom: '10px' }}
              >
                Agregar Suscriptor
              </CustomButton>

              <GeneralTableBox sx={{ boxShadow: '5px 5px 20px rgba(1,2,10,0.3)' }}>
                <Table aria-label="subscribers table">
                  <TableHead>
                    <TableRow>
                      <HeadTableCell>DNI</HeadTableCell>
                      <HeadTableCell>Nombre</HeadTableCell>
                      <HeadTableCell>Cuota Social</HeadTableCell>
                      <HeadTableCell>Seg. Vida (%)</HeadTableCell>
                      <HeadTableCell>Postal/Mail</HeadTableCell>
                      <HeadTableCell wmd="150px">Acciones</HeadTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(localContract.subscribers || []).map((subscriber, key) => (
                      <TableRow key={key}>
                        <RowTableCell>{subscriber?.subscriber?.dni || ''}</RowTableCell>
                        <RowTableCell>
                          {subscriber?.subscriber
                            ? `${subscriber.subscriber.last_name}, ${subscriber.subscriber.first_name}`
                            : ''}
                        </RowTableCell>
                        <RowTableCell sx={{ textAlign: 'center' }}>
                          {subscriber?.social_fee_payment ? 'SI' : 'NO'}
                        </RowTableCell>
                        <RowTableCell sx={{ textAlign: 'center' }}>
                          {subscriber?.life_insurance_percentage || 0}
                        </RowTableCell>
                        <RowTableCell sx={{ textAlign: 'center' }}>
                          {subscriber?.postage_address ? 'SI' : 'NO'} /{' '}
                          {subscriber?.mail_coupon ? 'SI' : 'NO'}
                        </RowTableCell>
                        <RowTableCell
                          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                          <CustomButton
                            variant="contained"
                            onClick={() => handleEditSubscriber(subscriber)}
                            disabled={disableEdition}
                            sx={{ width: '40px', height: '40px', marginRight: '5px' }}
                          >
                            <IconButton size="small">
                              <EditIcon sx={{ color: 'whitesmoke' }} />
                            </IconButton>
                          </CustomButton>
                          <CustomButton
                            variant="danger"
                            onClick={() =>
                              handleDeleteSubscriber(subscriber.subscriber.uuid, localContract.uuid)
                            }
                            disabled={disableEdition}
                            sx={{ width: '40px', height: '40px' }}
                          >
                            <IconButton size="small">
                              <DeleteIcon sx={{ color: 'whitesmoke' }} />
                            </IconButton>
                          </CustomButton>
                        </RowTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>

                {!disableEdition &&
                  (localContract.subscribers?.length === 0 ||
                    localContract.subscribers?.length === 1) && (
                    <Box
                      sx={{
                        mt: 2,
                        p: 2,
                        border: `2px solid ${
                          localContract.subscribers?.length === 0 ? '#d44242' : '#5e894f'
                        }`,
                        borderBottomLeftRadius: 5,
                        borderBottomRightRadius: 5,
                        backgroundColor: '#f5f5f5',
                        color: localContract.subscribers?.length === 0 ? '#d44242' : '#5e894f',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Typography>
                        {localContract.subscribers?.length === 0
                          ? MESSAGES.SUBSCRIBER_REMOVED
                          : MESSAGES.SUBSCRIBER_ADDED}
                      </Typography>
                    </Box>
                  )}
              </GeneralTableBox>
            </Box>
          </Grid>
        </Box>
      </DialogContent>
    </Box>
  );
};

export default SubscribersTab;
